import type { RetrofitName } from '@/shared/types/assessment.types'

/**
 * Enum representing which field is required for a retrofit type.
 * Used for both validation and UI display purposes.
 */
export enum RetrofitRequiredField {
  POWER = 'POWER',
  AREA = 'AREA',
  NONE = 'NONE',
}

/**
 * Returns which field is required for a given retrofit type.
 * - Heat pumps and heating systems require power (powerInKw)
 * - Most building envelope retrofits require area (componentAreaInSqm)
 * - Ventilation systems require no additional field
 */
export const getRetrofitRequiredField = (retrofitName: RetrofitName): RetrofitRequiredField => {
  const powerBasedRetrofits: RetrofitName[] = [
    'airWaterHeatPump',
    'airAirHeatPump',
    'groundSourceHeatPump',
    'pelletHeating',
  ]

  const noRequiredFieldRetrofits: RetrofitName[] = ['districtHeating', 'decentralVentilation']

  if (noRequiredFieldRetrofits.includes(retrofitName)) {
    return RetrofitRequiredField.NONE
  }

  return powerBasedRetrofits.includes(retrofitName)
    ? RetrofitRequiredField.POWER
    : RetrofitRequiredField.AREA
}
